import React from 'react'

export const JetSportBox = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {
  const { className, ...rest } = props
  return <div ref={ref}
              className={`relative rounded-md border border-solid border-borderGray bg-white flex flex-col ${className}`} {...rest}>
    {props.children}
  </div>
})